export const getDesignTokens = (mode) => ({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    fontFamily: "'Inter', sans-serif",
    h1: { fontFamily: "'Sora', sans-serif" },
    h2: { fontFamily: "'Sora', sans-serif" },
    h3: { fontFamily: "'Sora', sans-serif" },
    h4: { fontFamily: "'Sora', sans-serif" },
    h5: { fontFamily: "'Sora', sans-serif" },
    h6: { fontFamily: "'Sora', sans-serif" },
    body1: {
      fontFamily: "'Inter', sans-serif",
      fontWeight: 300,
      fontSize: "1.1rem",
      lineHeight: "1.6",
    },
    body2: {
      fontFamily: "'Inter', sans-serif",
      fontWeight: 300,
      fontSize: "1.05rem",
      lineHeight: "1.6",
      marginBottom: "0.75rem",
    },
    caption: {
      fontFamily: "'Inter', sans-serif",
      fontWeight: 600,
      fontSize: "0.625rem",
      lineHeight: "1.3",
    },
  },
  shape: {
    borderRadius: 12,
  },
  palette: {
    mode,
    ...(mode === "light"
      ? {
          primary: {
            main: "#6B63C4",
            light: "#9C96D6",
            dark: "#4D46A8",
            contrastText: "#FFF",
          },
          secondary: {
            main: "#2CC8A0",
            light: "#60D9BB",
            dark: "#1EAA85",
          },
          warning: {
            main: "#FDC63F",
          },
          success: {
            main: "#2CC8A0",
          },
          background: {
            default: "#EDE9F9",
            paper: "#FFFFFF",
          },
          text: {
            primary: "#363A3C",
            secondary: "#5a6068",
          },
        }
      : {
          primary: {
            main: "#9C96D6",
            light: "#BEB9E8",
            dark: "#6B63C4",
          },
          secondary: {
            main: "#60D9BB",
            light: "#8FE8D3",
            dark: "#2CC8A0",
          },
          background: {
            default: "#1a1c1e",
            paper: "#2a2d30",
          },
          text: {
            primary: "#F1F5F9",
            secondary: "#CBD5E1",
          },
        }),
  },
});

export const getThemedComponents = (mode) => ({
  components: {
    // Both Modes
    MuiInputBase: {
      styleOverrides: {
        root: {
          "& input": {
            "&:-webkit-autofill": {
              transition:
                "background-color 50000s ease-in-out 0s, color 50000s ease-in-out 0s",
            },
          },
        },
      },
    },
    MuiInputLabel: {
      defaultProps: {
        sx: {
          fontSize: "1.3rem",
          lineHeight: "1.75rem",
          fontWeight: 500,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& > fieldset > legend": {
            fontSize: `calc(0.75 * 1.3rem)`,
            fontWeight: 400,
          },
        },
      },
    },
    MuiRichTreeView: {
      styleOverrides: {
        root: {
          "& .MuiTreeItem-label": {
            fontSize: "1rem!important",
          },
        },
      },
    },
    // Customize Links to appear as Chips
    MuiLink: {
      defaultProps: {
        underline: "none",
      },
      styleOverrides: {
        root: {
          display: "inline-flex",
          alignItems: "center",
          padding: "4px 8px",
          borderRadius: "16px",
          backgroundColor: mode === "light" ? "#6B63C4" : "#9C96D6",
          color: mode === "light" ? "#FFF" : "#363A3C",
          fontWeight: 500,
          fontSize: "0.875rem",
          transition: "background-color 0.3s ease",
          cursor: "pointer",
          textDecoration: "none",
          "&:hover": {
            backgroundColor: mode === "light" ? "#4D46A8" : "#BEB9E8",
            textDecoration: "none",
          },
          "&:focus": {
            outline: "none",
            boxShadow:
              mode === "light"
                ? "0 0 0 2px rgba(107, 99, 196, 0.5)"
                : "0 0 0 2px rgba(156, 150, 214, 0.5)",
          },
        },
      },
    },
  },
});
